'use strict';

var BaseGroup = require('config/Group');
var i18n = require('i18next');
var RenderPositions = require('config/RenderPositions');

/**
 * "Failover Policy Control" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'failoverPolicyControl',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
      doubleWide: false,
    },
  ],

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.failoverPolicyControl');
  },

  /**
   * Overridden to prevent base Group class from trying to
   * combine multiple failover policies into one
   */
  shouldMergeTasks: false,
});
